import { useState } from 'react'
import { LegalModal } from '@/components/LegalModal'
import { PRIVACY_CONTENT } from '@/lib/privacyContent'

const TERMS_CONTENT = `
# Términos de Uso

**Última actualización: julio de 2026**

## 1. Aceptación de los términos

Al acceder y utilizar el Servicio John Anthony (en adelante, "el Servicio"), aceptas quedar vinculado por estos Términos de Uso. Si no estás de acuerdo con alguna parte de estos términos, no podrás acceder al Servicio.

## 2. Descripción del Servicio

John Anthony es una plataforma de análisis estadístico deportivo que opera a través de una Mini App de Telegram. El Servicio proporciona:

- Análisis estadísticos de partidos de fútbol.
- Recomendaciones generadas por sistemas de inteligencia artificial.
- Estadísticas de rendimiento históricas auditadas.
- Herramientas de gestión de bankroll (planes superiores).

## 3. Naturaleza del Servicio

**El Servicio es exclusivamente informativo y analítico.** John Anthony:

- NO es un servicio de apuestas deportivas.
- NO garantiza beneficios económicos de ningún tipo.
- NO asesora sobre decisiones financieras específicas.
- NO tiene relación con ninguna casa de apuestas.

Las decisiones de apostar y las apuestas realizadas son responsabilidad exclusiva del usuario.

## 4. Elegibilidad

Para usar el Servicio debes:

- Ser mayor de 18 años.
- Residir en una jurisdicción donde las apuestas deportivas sean legales.
- Tener una cuenta activa en Telegram.

## 5. Suscripciones y pagos

- Los planes de pago se facturan mensualmente de forma recurrente.
- Los pagos se procesan a través de Stripe o Bizum.
- Puedes cancelar tu suscripción en cualquier momento desde "Mi Suscripción" en la app.
- No se realizan reembolsos por períodos ya facturados.
- Los precios pueden cambiar con notificación previa de 30 días.

## 6. Uso aceptable

Queda prohibido:

- Redistribuir o revender los picks y análisis a terceros.
- Usar el Servicio con fines de lavado de dinero o actividades ilegales.
- Intentar acceder a funcionalidades no contratadas.
- Compartir credenciales de acceso con terceros.

## 7. Propiedad intelectual

Todos los contenidos, modelos, algoritmos y metodologías del Servicio son propiedad exclusiva de John Anthony y están protegidos por las leyes de propiedad intelectual aplicables.

## 8. Limitación de responsabilidad

En ningún caso John Anthony será responsable por:

- Pérdidas económicas derivadas de las apuestas realizadas.
- Decisiones tomadas basándose en los análisis del Servicio.
- Interrupciones técnicas del servicio de Telegram.

## 9. Modificaciones

Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios significativos se comunicarán con un mínimo de 15 días de antelación.

## 10. Juego responsable

Apostamos por el juego responsable. Si experimentas problemas con el juego:

- **España**: jugarbien.es | Tel: 900 200 225
- **FEJAR**: fejar.org
`

export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false)
  const [termsOpen, setTermsOpen] = useState(false)

  return (
    <>
      {privacyOpen && (
        <LegalModal
          title="Política de Privacidad"
          content={PRIVACY_CONTENT}
          onClose={() => setPrivacyOpen(false)}
        />
      )}
      {termsOpen && (
        <LegalModal
          title="Términos de Uso"
          content={TERMS_CONTENT}
          onClose={() => setTermsOpen(false)}
        />
      )}

      <footer className="border-t border-border bg-panel/30">
        <div className="max-w-5xl mx-auto px-5 py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            {/* Col 1: Brand */}
            <div className="space-y-4">
              <div className="flex items-center gap-2.5">
                <img src="/logo-96.png" alt="John Anthony" className="h-8 w-8 rounded-lg" />
                <span className="font-display text-lg font-bold tracking-tight">
                  JOHN <span className="text-brand">ANTHONY</span>
                </span>
              </div>
              <p className="text-xs text-text-dim leading-relaxed">
                Inteligencia artificial aplicada exclusivamente al análisis de fútbol.
                Picks Prematch. Datos auditados. Sin promesas vacías.
              </p>
              <div className="flex items-center gap-1.5">
                <span className="h-1.5 w-1.5 rounded-full bg-brand animate-pulse" />
                <span className="text-xs text-brand font-medium">Sistema operativo</span>
              </div>
            </div>

            {/* Col 2: Comunidad */}
            <div className="space-y-4">
              <h4 className="text-xs font-semibold uppercase tracking-wider text-text-dim">
                Comunidad
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <a
                    href="https://t.me/Jhon_sportbot"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-text-dim hover:text-brand transition-colors flex items-center gap-2"
                  >
                    <span>→</span> Telegram (Mini App)
                  </a>
                </li>
                <li>
                  <a
                    href="https://t.me/Jhon_sportbot"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-text-dim hover:text-brand transition-colors flex items-center gap-2"
                  >
                    <span>→</span> Canal de noticias
                  </a>
                </li>
              </ul>
            </div>

            {/* Col 3: Soporte */}
            <div className="space-y-4">
              <h4 className="text-xs font-semibold uppercase tracking-wider text-text-dim">
                Soporte
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <a
                    href="https://t.me/Jhon_sportbot"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-text-dim hover:text-brand transition-colors flex items-center gap-2"
                  >
                    <span>→</span> Soporte vía Telegram
                  </a>
                </li>
                <li>
                  <a
                    href="#faq"
                    className="text-sm text-text-dim hover:text-brand transition-colors flex items-center gap-2"
                  >
                    <span>→</span> Preguntas frecuentes
                  </a>
                </li>
              </ul>
            </div>

            {/* Col 4: Legal */}
            <div className="space-y-4">
              <h4 className="text-xs font-semibold uppercase tracking-wider text-text-dim">
                Legal
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <button
                    onClick={() => setPrivacyOpen(true)}
                    className="text-sm text-text-dim hover:text-brand transition-colors flex items-center gap-2 text-left"
                  >
                    <span>→</span> Política de privacidad
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setTermsOpen(true)}
                    className="text-sm text-text-dim hover:text-brand transition-colors flex items-center gap-2 text-left"
                  >
                    <span>→</span> Términos de uso
                  </button>
                </li>
                <li>
                  <span className="text-sm text-text-dim flex items-center gap-2">
                    <span>→</span> Solo mayores de 18 años
                  </span>
                </li>
                <li>
                  <a
                    href="https://www.jugarbien.es"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-text-dim hover:text-brand transition-colors flex items-center gap-2"
                  >
                    <span>→</span> Juego responsable
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-border pt-8 space-y-3">
            <p className="text-xs text-text-dim leading-relaxed max-w-3xl">
              <strong className="text-text/60">Aviso legal:</strong>{' '}
              John Anthony ofrece análisis e información estadística con fines informativos. No
              garantiza resultados económicos y ninguna apuesta está libre de riesgo. Servicio
              dirigido a mayores de 18 años. Las apuestas deportivas pueden generar adicción.
              Juega con responsabilidad.
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
              <p className="text-xs text-text-dim">
                © {new Date().getFullYear()} John Anthony. Todos los derechos reservados.
              </p>
              <div className="flex items-center gap-1.5 text-xs text-text-dim">
                <span>🔒</span>
                <span>Pagos seguros vía Stripe</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
